/*
 * Product layout is intentionally server-rendered.
 * Do not move Theme Editor blocks with JavaScript in this file.
 */
(() => {
  const locale = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
  const labels = {
    nl: { more: 'Lees meer', less: 'Minder tonen' },
    en: { more: 'Read more', less: 'Show less' },
    de: { more: 'Mehr lesen', less: 'Weniger anzeigen' },
    fr: { more: 'Lire la suite', less: 'Afficher moins' },
    es: { more: 'Leer más', less: 'Mostrar menos' },
    it: { more: 'Leggi di più', less: 'Mostra meno' }
  };
  const copy = labels[locale] || labels.en;
  document.querySelectorAll('.wn-product-buybox__description-more-label--more').forEach((el) => {
    el.textContent = copy.more;
  });
  document.querySelectorAll('.wn-product-buybox__description-more-label--less').forEach((el) => {
    el.textContent = copy.less;
  });
})();
